module.exports = __webpack_public_path__ + "img/vista-health-logo.7104431e.jpg";